import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { AskForPlanningForm, SimpleModal } from "src/app/components";
import { usePlanningMonthsOptions } from "src/app/hooks";
import useProjectManagersOptions from "src/app/hooks/useProjectManagersOptions/useProjectManagersOptions";
import { PlanningTransporter } from "src/app/transports/planning";
import { SiteSeoGrid } from "src/app/types/Site";
import { UpsertNewPlanningDTO, UpsertNewPlanningSchema } from "src/app/types/planning";

export interface IAskForPlanningContainer {
    selectedRows: SiteSeoGrid[];
    handlerValueToUpdateGrid?(update: boolean): void;
    handleClose(): void;
    showModal: boolean;
}
const AskForPlanningContainer = (props: IAskForPlanningContainer) => {
    const { selectedRows, handleClose, showModal, handlerValueToUpdateGrid = () => {} } = props;
    const { formatMessage } = useIntl();
    const { projectManagersOptions, loading: projectManagersOptionsLoading } =
        useProjectManagersOptions(true);
    const { planningMonthsOptions } = usePlanningMonthsOptions();
    const [loading, setLoading] = useState(false);

    const onSubmit = async (_values: UpsertNewPlanningDTO) => {
        const valuesToSubmit = selectedRows.map((row) => ({
            months: _values.months,
            moneySiteId: row.id,
            projectManagerId: _values.projectManagerId,
            orderType: _values.orderType,
            fillingValue: _values.fillingValue,
            rankingValue: _values.rankingValue,
            boostValue: _values.boostValue,
            discoverValue: _values.discoverValue,
            leadValue: _values.leadValue,
            netlinkingValue: _values.netlinkingValue,
            price: _values.price,
        }));
        setLoading(true);
        try {
            await PlanningTransporter.saveNew(valuesToSubmit);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handlerValueToUpdateGrid(true);
            handleClose();
        } catch (error: any) {
            toast.error(
                error?.response?.data?.errors[0]?.message ||
                    formatMessage({ id: "common.notification.error" })
            );
        } finally {
            setLoading(false);
        }
    };
    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.field.whoPlan" })}
            showModal={showModal}
            handleClose={handleClose}
            formId="addProjectManager"
            loading={loading}
            modalProps={{ size: "lg" }}
        >
            <Formik
                initialValues={UpsertNewPlanningSchema.getDefault()}
                validationSchema={UpsertNewPlanningSchema}
                onSubmit={(value: object) => onSubmit(value as UpsertNewPlanningDTO)}
            >
                <Form id="addProjectManager">
                    <AskForPlanningForm
                        planningMonthsOptions={planningMonthsOptions}
                        projectManagers={{
                            options: projectManagersOptions,
                            loading: projectManagersOptionsLoading,
                        }}
                    />
                </Form>
            </Formik>
        </SimpleModal>
    );
};

export default AskForPlanningContainer;
